import React from "react";
import { ErrorMessage, Field } from "formik";
import { Input, Select, Typography } from "antd";
import DatePicker from "react-datepicker";
import { format, parse } from "date-fns";

const { Option } = Select;
const { TextArea } = Input;

const InputFields = ({
  label,
  type,
  placeholder,
  name,
  options,
  disabled,
  className,
  iconRender
}) => {

  /* ================= SELECT ================= */
  if (type === "select") {
    return (
      <div>
        <label className="text-gray-800 dark:text-gray-200">
          <Typography.Text strong className="dark:text-gray-200">
            {label}
          </Typography.Text>
        </label>

        <Field name={name}>
          {({ field, form }) => (
            <Select
              {...field}
              placeholder={placeholder}
             className="
  w-full
  dark:[&_.ant-select-selector]:bg-gray-600
  dark:[&_.ant-select-selector]:border-gray-900
  dark:[&_.ant-select-focused_.ant-select-selector]:bg-gray-800
  dark:placeholder-gray-400

"

              onChange={(value) => form.setFieldValue(name, value)}
            >
              {options?.length > 0 ? (
                options.map((opt, idx) => (
                  <Option key={idx} value={opt.value}>
                    {opt.label}
                  </Option>
                ))
              ) : (
                <Option disabled>No Category Available</Option>
              )}
            </Select>
          )}
        </Field>

        <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
      </div>
    );
  }

  /* ================= TEXTAREA ================= */
  if (type === "textarea") {
    return (
      <div>
        <label className="text-gray-800 dark:text-gray-200">
          <Typography.Text strong className="dark:text-gray-200">
            {label}
          </Typography.Text>
        </label>

        <Field name={name}>
          {({ field }) => (
            <TextArea
              {...field}
              placeholder={placeholder}
              rows={2}
              className="
  w-full
  dark:bg-gray-800 dark:text-white dark:border-gray-600
  dark:hover:bg-gray-800
  dark:focus:bg-gray-800
  dark:placeholder-gray-400

"
            />
          )}
        </Field>

        <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
      </div>
    );
  }

  /* ================= PASSWORD ================= */
  if (type === "password") {
    return (
      <div>
        <label className="text-gray-800 dark:text-gray-200">
          <Typography.Text strong className="dark:text-gray-200">
            {label}
          </Typography.Text>
        </label>

        <Field name={name}>
          {({ field }) => (
            <Input.Password
              {...field}
              placeholder={placeholder}
              iconRender={iconRender}
              className="
  w-full
  dark:bg-gray-800 dark:text-white dark:border-gray-600
  dark:hover:bg-gray-800
  dark:focus:bg-gray-800
  dark:placeholder-gray-400

"
            />
          )}
        </Field>

        <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
      </div>
    );
  }

  /* ================= DATE ================= */
  if (type === "date") {
    return (
      <div>
        <label className="text-gray-800 dark:text-gray-200">
          <Typography.Text strong className="dark:text-gray-200">
            {label}
          </Typography.Text>
        </label>

        <Field name={name}>
          {({ field, form }) => {
            const parsedDate = field.value
              ? parse(field.value, "dd-MM-yyyy", new Date())
              : null;

            return (
              <DatePicker
                selected={parsedDate && !isNaN(parsedDate) ? parsedDate : null}
                onChange={(date) => {
                  if (date) {
                    form.setFieldValue(name, format(date, "dd-MM-yyyy"));
                  } else {
                    form.setFieldValue(name, "");
                  }
                }}
                wrapperClassName="w-full"
                placeholderText={placeholder}
                className="
  w-full !h-9 px-3 py-2 rounded-md
  bg-white text-black border
  dark:bg-gray-800 dark:text-white dark:border-gray-600
  dark:hover:bg-gray-800
  dark:focus:bg-gray-800
  dark:placeholder-gray-400
"
                dateFormat="dd-MM-yyyy"
                disabled={disabled}
              />
            );
          }}
        </Field>

        <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
      </div>
    );
  }

  /* ================= CHECKBOX ================= */
  if (type === "checkbox") {
    return (
      <div>
        <label className="text-gray-800 dark:text-gray-200">
          <Typography.Text strong className="dark:text-gray-200">
            {label}
          </Typography.Text>
        </label>

        <Field name={name}>
          {({ field }) => (
            <label className="flex items-center space-x-2 cursor-pointer
              bg-gray-200 dark:bg-gray-800 p-1 rounded w-fit">
              <input
                {...field}
                checked={field.value}
                type="checkbox"
                className={`w-5 h-5 rounded-sm
                  text-green-600 border-gray-300
                  focus:ring-green-500 checked:bg-green-500
                  dark:border-gray-600 ${className}
                  bg-gray-200 dark:bg-gray-800
hover:bg-gray-200 dark:hover:bg-gray-800`}
              />
              <span className="text-sm text-black dark:text-white">
                {placeholder || label}
              </span>
            </label>
          )}
        </Field>

        <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
      </div>
    );
  }

  /* ================= DEFAULT INPUT ================= */
  return (
    <div>
      <label className="text-gray-800 dark:text-gray-200">
        <Typography.Text strong className="dark:text-gray-200">
          {label}
        </Typography.Text>
      </label>

      <Field name={name}>
        {({ field }) => (
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
          className="
  w-full
  dark:bg-gray-800 dark:text-white dark:border-gray-600
  dark:hover:bg-gray-800
  dark:focus:bg-gray-800
  dark:placeholder-gray-400

"
          />
        )}
      </Field>

      <ErrorMessage name={name} component="div" className="text-red-500 text-sm mt-1" />
    </div>
  );
};

export default InputFields;
